export const handleCreator = (string: string) => {
  const arr = string.split("<");

  return arr[0].replace("Bernhard Schulz", "").replace("Location Logic Administrator", "").trim();
};
